import classNames from 'classnames';
import { ChangeEvent, FC, Ref } from 'react';

import MaterialIcon from '../MaterialIcon/MaterialIcon';
import style from './Form.module.scss';
import { Input, Textarea } from './FormInputs';

export type FormChangeEvent = ChangeEvent<HTMLInputElement | HTMLTextAreaElement>;

const fieldTypes: Record<'text' | 'textarea', React.ElementType> = {
  text: Input,
  textarea: Textarea,
};

export type FormElementProps ={
  disabled?: boolean;
  error?: string;
  fieldClassName?: string;
  label: string;
  name: string;
  onChange?: (event: FormChangeEvent) => void;
  split?: boolean;
  value: string;
} & (TextareaFields | TextFields);

type TextareaFields = {
  ref?: Ref<HTMLTextAreaElement | null>;
  type: 'textarea';
};

type TextFields = {
  ref?: Ref<HTMLInputElement | null>;
  type: 'text';
};

const FormElement: FC<FormElementProps> = ({
  type, name, value, onChange, label, disabled, split, error,
  fieldClassName = '', ref
}) => {
  const Component = fieldTypes[type];

  const formGroupClassNames = classNames({
    [style.formGroup]: true,
    [style.split]: split,
    [style.labelSpacing]: true,
    'partner-border-color': !error,
    'background-color-onfocus-dropshadow': !error
  });

  const labelClassNames = classNames({
    [style.label]: true,
    [style.labelVisible]: value,
    [style.labelError]: error
  });

  return (
    <div className={formGroupClassNames}>
      <label className={labelClassNames} htmlFor={name}>{label}</label>
      <Component
        className={classNames({
          [style.error]: error,
          [style.filled]: !!value && !disabled && !error,
          [fieldClassName]: !!fieldClassName,
        })}
        disabled={disabled}
        name={name}
        onChange={disabled ? undefined : onChange}
        placeholder={label}
        ref={ref}
        value={value}
      />
      {!!error && <MaterialIcon className={style.errorIcon} name="error" size={20} />}
      {!!error && <p className={style.msgError}>{error}</p>}
    </div>

  );
};

export default FormElement;
